// Flow types automatically removed

import { Fragment } from 'react';
import classnames from 'classnames';
import formStyles from '../styles/FormGeneral.scss';
import stepContactsStyles from '../styles/FormStepContacts.scss';
export const WrappedInput = props => (
    <Fragment>
        <div className={stepContactsStyles.columnWrapper}>
            <div className={formStyles.inputLabelWrapper}>{props.label}</div>
        </div>
        <div className={stepContactsStyles.columnWrapper}>
            <div className={formStyles.column}>{props.input}</div>
            {props.secondInput ? (
                <div className={classnames(formStyles.column, formStyles.marginLeft)}>
                    {props.secondInput}
                </div>
            ) : null}
        </div>
        <div className={stepContactsStyles.columnWrapper}>{props.subText}</div>
    </Fragment>
);
